import { Filters, Results } from './components';
import { Container, Grid, Typography } from '@mui/material';


let ReferenceData = () => {

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h4">Reference data</Typography>
            </Grid>
            <Grid item xs={12}>
                <Filters />
            </Grid>
            <Grid item xs={12}>
                <Results />
            </Grid>
        </Grid >
    )
}

export default ReferenceData;